module.exports = __webpack_public_path__ + "img/3.8362fff6.png";